// extracted by mini-css-extract-plugin
module.exports = {"title":"NewsAndStoriesBlock_title__1Wlvp","itemsBox":"NewsAndStoriesBlock_itemsBox__3cmZ3","button":"NewsAndStoriesBlock_button__1-qNB"};